export default {
  head: [
    {
      name: "NHP Home",
      path: "/",
      active: true,
    },

    {
      name: "Flood Home",
      path: "/webgis-flood",
      active: true,
    },
    {
      name: "Objective",
      path: "/webgis-flood/proj-obj",
    },
    {
      name:'Download Products',
      path:'/nhp-data-download'
    }

    // {
    //     name:"Technical Proposal",
    //     path:"/webgis-flood/tech-prop"

    // },
    // {
    //     name:"Project Team",
    //     path:"/webgis-flood/proj-team"

    // },
    // {
    //     name:"Financial Proposal",
    //     path:"/webgis-flood/fin-prop"
    // }
  ],

  breadCrumbs: [
    {
      name: "menu 1",
      path: "/",
    },
    {
      name: "menu 2",
      path: "/",
    },
    {
      name: "menu 3",
      path: "/",
    },
  ],

  mapSideBar: [
    // {
    //     "id": 1,
    //     "name": 'Snow Cover',
    //     "icon":"stroopwafel",
    //     "hasdefault":true,
    //     "children": [
    //         {
    //             "id": 1,
    //             "name": 'Daily Snow Cover',
    //             "icon":"stroopwafel",
    //             "dateReq":true,
    //             "sliderReq":true,
    //             "ismap":true,
    //             "default":true,
    //             "graphstatus":false,
    //             "information":"Daily Snow cover Area "

    //         },
    //         {
    //             "id": 2,
    //             "name": 'Snow Cover Fraction',
    //             "icon":"stroopwafel",
    //             "sliderReq":true,
    //             "ismap":true,
    //            // "graphstatus":true,
    //             "information":"Snow Cover fraction products are fortnightly generating"

    //         }],
    //     },
    {
      id: 1,
      name: "Reservoir",
      displayname: "Reservoir",

      icon: "stroopwafel",
      forecast: true,
      hasdefault: true,
      active: true,
      children: [
      
        {
          id: 1,
          name: "Reservoir",
          displayname:"#",
          icon: "stroopwafel",
          issub: true,
          // "sliderReq":true,
          // "dateReq":true,
          default: true,
        },

      ],
    },

    {
      id: 2,
      name: "Hydrograph",
      displayname: "Hydrograph",
      icon: "stroopwafel",
      forecast: true,
      hasdefault: true,
      active: false,
      children: [
        
        {
          id: 1,
          name: "Hydrograph",
          displayname:"#",
          icon: "stroopwafel",
          issub: true,
          // "sliderReq":true,
          // "dateReq":true,
          default: true,
        },
      ],
    },
    {
      id: 3,
      name: "Inundation Simulation",
      displayname: "Inundation Simulation",
      icon: "stroopwafel",
      forecast: true,
      hasdefault: true,
      active: false,
      children: [
        // {
        //     "id": 1,
        //     "name": "Runoff Map",
        //     "icon":"stroopwafel",
        //     "issub":true,
        //     "sliderReq":true,
        //     "dateReq":true,
        //     "default":true,
        // },
        {
          id: 1,
          name: "Inundation Simulation",
          displayname: "#",
          icon: "stroopwafel",
          // "ismap":true,
          // "dateReq":true,
          // "sliderReq":true,
          issub: true,
          // "dateReq":true,
          // "sliderReq":true,
        },
        /*
        {
          id: 2,
          name: "Event Simulation",
          displayname: "Event Simulation",

          icon: "stroopwafel",
          // "ismap":true,
          // "dateReq":true,
          // "sliderReq":true,
          issub: true,
          disabled:true,
          // "dateReq":true,
          // "sliderReq":true,
        },*/
        {
          id: 3,
          name: "6 Hourly Simulations",
          displayname: "6 Hourly Simulations",
          icon: "stroopwafel",
          // "ismap":true,
          // "dateReq":true,
          // "sliderReq":true,
          issub: true,
          // "dateReq":true,
          // "sliderReq":true,

          
        },
        {
          id: 4,
          name: "Event Simulation",
          displayname: "Event Simulation",
          icon: "stroopwafel",
          // "ismap":true,
          // "dateReq":true,
          // "sliderReq":true,
          issub: true,
          // "dateReq":true,
          // "sliderReq":true,
        },
      ],
      
      
    },
    // {
      
    //     id: 4,
    //     name: "Event Simulation",
    //     displayname: "Event Simulation",
    //     icon: "stroopwafel",
    //     forecast: true,
    //     hasdefault: true,
    //     active: false,
    //     children: [
    //       {
    //     id: 1,
    //   name: "Event Simulation",
    //   displayname: "Event Simulation",
    //   icon: "stroopwafel",
    //   forecast: true,
    //   hasdefault: true,
    //   active: false
    //       }
    //     ]
    // }
    // {
    //     "id": 1,
    //     "name": 'Disclaimer',
    //     "displayname":"Disclaimer",
    //     "icon":"stroopwafel",
    //     "popup":true,
    //   //  "info":"",

    // },
    // {
    //     "id": 1,
    //     "name": 'Technical Note',
    //     "displayname":"Technical Note",
    //     "icon":"stroopwafel",
    //     "popup":true,
    //   //  "info":"",

    // },

    // {
    //     "id": 4,
    //     "name": 'Spatial Snowmelt Actual Data',
    //     "icon":"stroopwafel",
    //     "dateReq":true,
    //     "ismap":true,

    // },

    // {
    //     "id": 3,
    //         "name": 'Base Layers',
    //         "icon":"stroopwafel",
    //         "hasdefault":true,
    //         "children": [
    //             {
    //                 "id": 1,
    //                 "name": 'DEM',
    //                 "icon":"stroopwafel",
    //                 "ismap":true,

    //             },

    //             {
    //                 "id": 2,
    //                 "name": 'Satellite Imagery',
    //                 "icon":"stroopwafel",
    //                 "ismap":true,

    //             },
    //             {
    //                 "id": 3,
    //                 "name": 'River Network',
    //                 "icon":"stroopwafel",
    //                 "ismap":true,

    //             },
    //             {
    //                 "id": 4,
    //                 "name": 'Administrative',
    //                 "icon":"stroopwafel",
    //                 "ismap":true,

    //             },
    //             {
    //                 "id": 5,
    //                 "name": 'Infrastructure',
    //                 "icon":"stroopwafel",
    //                 "ismap":true,

    //             },
    //             {
    //                 "id": 5,
    //                 "name": 'LULC',
    //                 "icon":"stroopwafel",
    //                 "ismap":true,

    //             }
    //             // {

    //             // }
    //         ]
    //     }
    // {
    //     "id": 3,
    //         "name": 'Analysis',
    //         "icon":"stroopwafel",
    //         "children": [
    //             {
    //                 "id": 1,
    //                 "name": 'Basin',
    //                 "icon":"stroopwafel",

    //             },

    //             {
    //                 "id": 2,
    //                 "name": 'SubBasin',
    //                 "icon":"stroopwafel",

    //             }
    //         ]
    // }
  ],
};
